import { createContext, useContext, useEffect, useState } from "react";

import { APP_DEFAULT_THEME } from "../constants/common";

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const getInitialTheme = () => {
    const storedTheme = localStorage.getItem("theme");

    if (!storedTheme || storedTheme === "undefined") {
      return APP_DEFAULT_THEME;
    }

    return storedTheme;
  };

  const [theme, setTheme] = useState(getInitialTheme);

  useEffect(() => {
    const themeLink = document.getElementById("prime-theme");

    if (theme === "dark") {
      document.documentElement.classList.add("dark");
      themeLink.href = "https://unpkg.com/primereact/resources/themes/lara-dark-blue/theme.css";
    } else {
      document.documentElement.classList.remove("dark");
      themeLink.href = "https://unpkg.com/primereact/resources/themes/lara-light-blue/theme.css";
    }

    localStorage.setItem("theme", theme);
  }, [theme]);

  return <ThemeContext.Provider value={{ theme, setTheme }}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => useContext(ThemeContext);
